export default __webpack_public_path__ + "model-type-images/flesh-inactive.svg";